<script lang="ts">
	let className = ""
	export { className as class };
	// TODO: Remove and replace with shadcnui skeleton
</script>

<div class={"animate-pulse rounded bg-xerteal-600/10" + (className ? ` ${className}` : "")}/>